<template>
  <div class="default-layout min-height-page flex-column">
    <site-header class=""></site-header>
    <main class="">
      <slot></slot> 
    </main>
    <site-footer style="margin-top:auto;"></site-footer>
    <site-credits></site-credits>
  </div>
</template>

<script>


import SiteFooter from '@/client/applications/agaloola/components/stracture/SiteFooter';
import SiteHeader from '@/client/applications/agaloola/components/stracture/SiteHeader'

export default {
  components: {
    SiteHeader,SiteFooter,
  },
  props: {
    title: {
      type: [Boolean, String],
      default: false,
    },
    titleParams: {
      type: [Object],
      default: {},
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  z-index: var(--z-1);
  padding-block: var(--margin-max);

  @media (max-width: 767px) {
    padding-block: var(--margin-xl);
  }
}

.top-divider {
  position: relative;

  background: rgb(160, 43, 126);
  background: radial-gradient(
    circle,
    rgba(160, 43, 126, 1) 0%,
    rgba(83, 156, 212, 1) 100%
  );

  height: 240px;
  top: -0px;
  z-index: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-bottom: 3px solid var(--c-alt);

  @media (max-width: 767px) {
    height: 180px;
  }

  &.no-image {
    height: 200px;
    border-bottom: none;

    @media (max-width: 767px) {
      height: 120px;
    }
  }

  &__shader {
    background-color: var(--);
  }

  .hero-content {
    max-height: 100%;
    overflow: hidden;

    &__title {
      font-size: calc(60 * var(--base-font-size));

      @media (max-width: 767px) {
        font-size: var(--font-max);
        text-align: center;
      }
    }
  }
}

.top-divider-shape {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);
  z-index: var(--z-5);

  svg {
    display: none;
    // display: block;
    position: relative;
    width: calc(119% + 1.3px);
    height: 80px;
  }

  .shape-fill {
    fill: var(--c-bg);
  }
}

.top-divider-shape-mobile {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  z-index: var(--z-5);

  svg {
    position: relative;
    //display: block;
    display: none;
    width: calc(185% + 1.3px);
    height: 50px;
  }

  .shape-fill {
    fill: var(--c-bg);
  }
}

.bottom-divider {
  // display: block;
  display: none;
  height: 275px;
  top: 0px;
  position: relative;
  background: rgb(83, 156, 212);
  background: linear-gradient(0deg, rgba(83, 156, 212, 1) 0%, rgba(160, 43, 126, 1) 100%);
  z-index: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 767px) {
    height: 150px;
    top: -25px;
  }
}

.bottom-divider-shape {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);

  svg {
    position: relative;
    display: block;
    width: calc(159% + 1.3px);
    height: 142px;
  }

  .shape-fill {
    fill: var(--c-bg);
  }
}

.bottom-divider-shape-mobile {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);

  svg {
    position: relative;
    display: block;
    width: calc(159% + 1.3px);
    height: 49px;
  }
  .shape-fill {
    fill: var(--c-bg);
  }
}
</style>
